export const byte2Kb = (size: number) => {
  return size / 1024;
};

export function extractPathAndFilename(filePath: string): {
  path: string;
  filename: string;
} {
  const lastSlashIndex = filePath.lastIndexOf("/");
  const path = filePath.substring(0, lastSlashIndex + 1);
  const filename = filePath.substring(lastSlashIndex + 1);

  return { path, filename };
}

export function arrayUnion<T>(value: T, array: T[]) {
  const newArray = array.filter((item) => item !== value);
  newArray.push(value);
  return newArray;
}

export function arrayRemove<T>(value: T, array: T[]) {
  return array.filter((item) => item !== value);
}

export function arrayUnique<T>(array: T[]): T[] {
  return [...new Set(array)];
}

export function compareNoCase(a: string, b: string) {
  a = a.toLowerCase();
  b = b.toLowerCase();
  return a < b ? -1 : a > b ? 1 : 0;
}

export function truncateText(
  str: string,
  length: number = 100,
  ellipsis: string = "..."
) {
  if (str.length > length) {
    return str.slice(0, length - ellipsis.length) + ellipsis;
  }
  return str;
}
